abstract class CacheTarget {

  static readonly key: string;

  abstract get key(): string;
  abstract toJSON(): object;

}

export { CacheTarget };